import { Codicon } from '../../../../base/common/codicons.js';
import { localizeWithPath } from '../../../../nls.js';
import { registerIcon } from '../../../../platform/theme/common/iconRegistry.js';
const _moduleId = "vs/workbench/contrib/multiDiffEditor/browser/icons.contribution";
const MultiDiffEditorIcon = registerIcon('multi-diff-editor-label-icon', Codicon.diffMultiple, ( localizeWithPath(_moduleId, 0, 'Icon of the multi diff editor label.')));
export { MultiDiffEditorIcon };
